export default __webpack_public_path__ + "static/media/OutOfBed.1b55bafd.svg";